export enum SearchToolingConfigTypeEnum {
  EQUALIZE = 'equalize',
}
